import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './admin.css';

// Componente para proteger rotas administrativas
const ProtectedRoute = ({ requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  // Mostrar indicador de carregamento enquanto verifica a autenticação
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  // Verificar se o usuário está autenticado
  if (!isAuthenticated()) {
    // Redirecionar para a página de login se não estiver autenticado
    return <Navigate to="/login" replace />;
  }

  // Verificar se o usuário tem permissões de administrador (se necessário)
  if (requireAdmin && !isAdmin()) {
    // Redirecionar para a página inicial se não tiver permissões de administrador
    return <Navigate to="/" replace />;
  }

  // Renderizar as rotas protegidas
  return <Outlet />;
};

export default ProtectedRoute;
